import { styled } from '@mui/material/styles';
import Card from '@components/Card';
import { Typography } from '@components/Typography';
import { ProfileName } from '@constants/integrations';

const CardAddress = styled('p', {
    shouldForwardProp: prop => prop !== 'disabled',
})(({ disabled }) => ({
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 500,
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: 'rgba(0, 0, 0, 0.6)',
    marginTop: 0,
    marginBottom: 8,
    ...(disabled && {
        color: 'rgba(0, 0, 0, 0.38)',
    }),
}));

const generateAddress = addr => {
    return `${addr.address || ''}, ${addr.city || ''}, ${addr.postalCode || ''}, ${addr.country || ''}`;
};

const LocationCard = ({ location = {}, title, selectedLocation, setLocation, integrationType, integrationIdProp }) => {
    const isDisabled = location.connected;
    const isCoverManager = integrationType === ProfileName.CoverManager;

    return (
        <Card
            type="radio"
            selected={location[integrationIdProp] === selectedLocation[integrationIdProp] && !isDisabled}
            title={title}
            value={location[integrationIdProp]}
            setValue={() => setLocation(location)}
            disabled={isDisabled}
        >
            {isCoverManager && <CardAddress disabled={isDisabled}>{generateAddress(location)}</CardAddress>}
            {isDisabled && (
                <Typography
                    variant="caption"
                    sx={{
                        color: '#fff',
                        backgroundColor: '#416774',
                        padding: '2px 6px',
                        borderRadius: '18px',
                        width: 'fit-content',
                        marginTop: isCoverManager ? '16px' : 0,
                    }}
                >
                    {location.connectedLocationName}
                </Typography>
            )}
        </Card>
    );
};

export default LocationCard;
